import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Form, FormActions, FormInput } from '../../../components/form/index.js';
import { useUsersContext } from '../../../contexts/users.tsx';
import { UserRegisterModel } from '../../../models/users/userRegisterModel.ts';

const validationSchema = Yup.object().shape({
    userName: Yup.string().required('Username is required').min(2, 'Username is too short').max(255, 'Username is too long'),
    firstName: Yup.string().required('First name is required').min(2, 'First name is too short').max(255, 'First name is too long'),
    lastName: Yup.string().required('Last name is required').min(2, 'Last name is too short').max(255, 'Last name is too long'),
    email: Yup.string().required('Email is required').min(5, 'Email is too short').max(255, 'Email is too long'),
    password: Yup.string().required('Password is required').min(8, 'Password is too short').max(255, 'Password is too long'),
    confirmPassword: Yup.string().required('Confirm Password is required').oneOf([Yup.ref('password')], 'Passwords must match'),
});

const RegisterBody = () => {
    const { register } = useUsersContext();
    const navigate = useNavigate();
    const [userRegisterModel, setUserRegisterModel] = useState<UserRegisterModel>({ userName: '', firstName: '', lastName: '', email: '', password: '' } as UserRegisterModel);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;
        setUserRegisterModel((prevData) => ({
            ...prevData,
            [id]: value, // Update the corresponding field in state
        }));

        validationSchema
            .validateAt(id, { ...userRegisterModel, [id]: value })
            .then(() => setErrors((prev) => ({ ...prev, [id]: '' })))
            .catch((err) => setErrors((prev) => ({ ...prev, [id]: err.message })));
    };

    const handleSubmit = () => {
        validationSchema
            .validate(userRegisterModel, { abortEarly: false })
            .then(() => {
                register(userRegisterModel);
            })
            .catch((err) => {
                const validationErrors: Record<string, string> = {};
                err.inner.forEach((error: Yup.ValidationError) => {
                    if (error.path) validationErrors[error.path] = error.message;
                });
                setErrors(validationErrors);
            });
    };
    return (
        <Form>
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='userName' label='Username' errors={errors} />
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='firstName' label='First name' errors={errors} />
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='lastName' label='Last name' errors={errors} />
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='email' label='Email' errors={errors} />
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='password' label='Password' errors={errors} />
            <FormInput entity={userRegisterModel} handleInputChange={handleInputChange} fieldName='confirmPassword' label='Confirm password' type='password' errors={errors} />
            <FormActions
                mainAction={handleSubmit}
                mainActionText={"Register"}
                secondaryAction={() => navigate("/login")}
                secondaryActionText={"Login"}
                overrideIsLoggedIn={true} />
        </Form>
    );
};

export default RegisterBody;